import { useLocation } from 'react-router-dom';

import { INITIAL_PAGE_PARAM } from 'apps/promo/constants/utmParams';
import { addTrackingParamsToUrl } from 'apps/promo/helpers/utmParams';
import { useCookies } from 'apps/promo/hooks/useCookies';
import { useQuery } from 'apps/promo/hooks/useQuery';

export const useUrlWithTrackingParams = (): ((url: string | undefined | null) => string | undefined | null) => {
    const query = useQuery();
    const cookies = useCookies();
    const { pathname } = useLocation();
    const initialPage = query.get(INITIAL_PAGE_PARAM) || (cookies.get(INITIAL_PAGE_PARAM) as string | undefined) || pathname;

    return (url: string | undefined | null) => addTrackingParamsToUrl(url, query, initialPage);
};
